module.exports = __webpack_public_path__ + "img/compact.71451cfb.png";